export function delayAsync(ms: number): Promise<void> {
  return new Promise((r) => window.setTimeout(r, ms));
}

export function isIOS(): boolean {
  const userAgent = navigator.userAgent;
  return /iPad|iPhone|iPod/i.test(userAgent) ? true : false;
}

export function isAndroid(): boolean {
  const userAgent = navigator.userAgent;
  return /android/i.test(userAgent) ? true : false;
}

export function hasValue<T>(obj: T): boolean {
  return obj !== null && obj !== undefined;
}